import { api } from './client';

type Envelope<T> = { data: T };

export type FolderView = {
  id: string;
  name: string;
  color: string;
  count: number;
  createdAt: string;
};

export type FolderList = {
  folders: FolderView[];
  unfiledCount: number;
};

export type FolderStatusCounts = {
  draft: number;
  sent: number;
  in_progress: number;
  completed: number;
  declined: number;
  voided: number;
  expired: number;
  total: number;
};

export type AdminFolderRow = {
  id: string;
  name: string;
  color: string;
  createdAt: string;
  counts: FolderStatusCounts;
};

export type AdminFoldersOverview = {
  folders: AdminFolderRow[];
  unfiled: FolderStatusCounts;
};

export const foldersApi = {
  async list(): Promise<FolderList> {
    const { data } = await api.get<Envelope<FolderList>>('/folders');
    return data.data;
  },

  async create(input: { name: string; color?: string }): Promise<{ id: string; name: string; color: string }> {
    const { data } = await api.post<Envelope<{ id: string; name: string; color: string }>>(
      '/folders',
      input,
    );
    return data.data;
  },

  async rename(uuid: string, input: { name?: string; color?: string }): Promise<void> {
    await api.patch(`/folders/${uuid}`, input);
  },

  async delete(uuid: string): Promise<void> {
    await api.delete(`/folders/${uuid}`);
  },

  async moveEnvelope(envelopeUuid: string, folderId: string | null): Promise<void> {
    await api.patch(`/folders/move/${envelopeUuid}`, { folderId });
  },

  async adminOverview(): Promise<AdminFoldersOverview> {
    const { data } = await api.get<Envelope<AdminFoldersOverview>>('/folders/admin/overview');
    return data.data;
  },
};
